<template>
  <div class="manual-steps">
    <h1 class="manual-steps__title">Getting Started with Good Casper</h1>
    
    <div class="manual-steps__timeline">
      <div v-for="(section, index) in sections" 
           :key="index" 
           class="timeline-section"
           :class="{'timeline-section--highlight': index % 2 === 0}"
           :style="{ '--index': index }">
        
        <div class="timeline-section__header">
          <div class="timeline-number">
            <span>{{ index + 1 }}</span>
          </div>
          <h2 class="timeline-title">{{ section.title }}</h2>
        </div>

        <div class="timeline-content">
          <div v-for="(step, stepIndex) in section.steps"
               :key="stepIndex"
               class="timeline-step"
               v-html="step">
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ManualSteps",
  data() {
    return {
      sections: [
        {
          title: "Create a Free Account",
          steps: [
            "Sign up with an email and password",
            "Verify your email to access the platform",
          ],
        },
        {
          title: "Create a Free Profile for Your Deceased Person or Pet",
          steps: [
            // "Choose between a <strong class='white--text'>free</strong> or <strong class='white--text'>paid</strong> package based on your needs",
            // "<strong class='white--text'>Special Offer:</strong> The first <strong class='white--text'>1000 profiles</strong> are <strong class='white--text'>free forever</strong> and include the <strong class='white--text'>premium package</strong>",
            // "Paid packages are available on a <strong class='white--text'>monthly</strong> or <strong class='white--text'>yearly</strong> basis <br>(yearly plans include a <strong class='white--text'>2-month discount</strong>)",
            // "You can <strong class='white--text'>upgrade</strong> or <strong class='white--text'>downgrade</strong> your package at any time",
            `Enter details about the deceased, including:
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Appearance:</strong> Eye color, height, weight, etc.</span>
            <br><span style="font-size: 0.9em; margin-left: 10px;">- <strong class='gradient-text'>Favorite Things:</strong> Music, hobbies, places they loved, etc.</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Grave Location:</strong> (Optional) Add a location for visitors.</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Other personal details</strong> to keep their memory alive.</span>`,
            // "You can <strong class='white--text'>modify all details</strong> later if needed",
            "Receive a <strong class='gradient-text'>QR code</strong> linked to the profile, which you can download and print",
            `Place the QR code on meaningful locations such as:
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Gravestones</strong></span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Memorial plaques</strong></span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Obituaries</strong> (newspaper or online)</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Personal keepsakes</strong> (photo frames, books, jewelry)</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='gradient-text'>Public remembrance sites</strong></span>`,
          ],
        },
        {
          title: "Invite People to Follow the Profile",
          steps: [
            "Send invitations to family and friends to join and follow the profile",
            "They can view and interact with the memorial once approved",
          ],
        },
        {
          title: "Explore & Connect",
          steps: [
            "Search for other deceased profiles (pets or people)",
            "Send <strong class='gradient-text'>follow requests</strong> to profiles you want to stay connected with",
          ],
        },
        {
          title: "Manage Follow Requests",
          steps: [
            "You receive follow requests for the profiles you own",
            "Approve or reject requests to control who can interact",
          ],
        },
        {
          title: "Enrich & Share the Profile",
          steps: [
            "Add a <strong class='gradient-text'>Last Greeting</strong> - a personal message in honor of the deceased",
            "<strong class='gradient-text'>Upload images</strong>, <strong class='gradient-text'>videos</strong>, and <strong class='gradient-text'>documents</strong> to keep their memory alive",
            // `<strong class='white--text'>Info Section for Images/Videos:</strong>
            // <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='white--text'>Location</strong></span>
            // <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='white--text'>Title</strong></span> 
            // <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='white--text'>Description</strong></span> 
            // <br><span style="font-size: 0.9rem; margin-left: 10px;">- <strong class='white--text'>Date</strong></span>`,
            `Create a <strong class='gradient-text'>Timeline</strong>,
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Add key life events with <strong class='gradient-text'>linked text</strong>, <strong class='gradient-text'>images</strong>, and <strong class='gradient-text'>videos</strong>.</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Organize important moments, such as <strong class='gradient-text'>birthdays</strong>, <strong class='gradient-text'>achievements</strong>, <strong class='gradient-text'>personal milestones</strong>, or any <strong class='gradient-text'>significant memories</strong></span>`,
            `<strong class='gradient-text'>Missing Puzzle</strong> - Community Image Contributions:
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Friends and followers can <strong class='gradient-text'>suggest images</strong> of the deceased.</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- The profile owner can <strong class='gradient-text'>approve or reject</strong> these suggestions before adding them.</span>`,
            `<strong class='gradient-text'>Weekly Tales</strong> (Short Stories):
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Upload short images that last for <strong class='gradient-text'>7 days</strong></span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Share fleeting memories, tributes, or moments related to the deceased</span>`,
            `<strong class='gradient-text'>Automated Remembrance Notifications</strong>:
            <br><span style="font-size: 0.9rem; margin-left: 10px;">The profile owner and all followers receive an <strong class='gradient-text'>email notification</strong> on:</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- The deceased's <strong class='gradient-text'>birthday</strong></span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- The death <strong class='gradient-text'>anniversary</strong>,</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">Encourages users to revisit the profile, share memories, or leave a tribute</span>`,
            `<strong class='gradient-text'>Share content</strong>:
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Share individual <strong class='gradient-text'>images</strong> and <strong class='gradient-text'>videos</strong>.</span>
            <br><span style="font-size: 0.9rem; margin-left: 10px;">- Share the <strong class='gradient-text'>entire profile</strong> with friends, family, or on social media</span>`,
            "Engage with others through <strong class='gradient-text'>comments</strong>, <strong class='gradient-text'>likes</strong>, and <strong class='gradient-text'>bookmarks</strong>",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.manual-steps {
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 24px;
  opacity: 0;
  animation: fadeIn 0.8s ease-out forwards;

  @media (max-width: 768px) {
    margin: 40px auto;
    padding: 0 16px;
  }
  
  &__title {
    font-family: 'Montserrat', sans-serif;
    font-size: clamp(2.5rem, 4vw, 3.5rem);
    font-weight: 800;
    text-align: center;
    background: linear-gradient(135deg, #FF6B6B, #4ECDC4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 80px;
    letter-spacing: -0.02em;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: clamp(1.8rem, 3vw, 2.2rem);
      margin-bottom: 40px;
      padding: 0 20px;
    }
  }

  &__timeline {
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      left: 24px;
      top: 0;
      bottom: 0;
      width: 2px;
      background: linear-gradient(180deg, 
        rgba(255,255,255,0.1) 0%,
        rgba(255,255,255,0.3) 50%,
        rgba(255,255,255,0.1) 100%);
      animation: timelineGrow 1.2s ease-out forwards;

      @media (max-width: 768px) {
        left: 24px;
      }
    }
  }
}

.timeline-section {
  position: relative;
  margin-bottom: 60px;
  padding-left: 64px;
  opacity: 0;
  transform: translateY(20px);
  animation: slideUp 0.6s ease-out forwards;
  animation-delay: calc(var(--index) * 0.2s);
  
  @media (max-width: 768px) {
    margin-bottom: 40px;
    padding-left: 48px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      gap: 12px;
      margin-bottom: 16px;
    }
  }
}

.timeline-number {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255,255,255,0.1);
  position: absolute;
  left: 0;
  z-index: 2;
  transition: transform 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: scale(1.05);
    border-color: rgba(255,255,255,0.2);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }

  span {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    background: linear-gradient(135deg, #fff 0%, #a8a8a8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
}

.timeline-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.5rem, 2.5vw, 1.75rem);
  font-weight: 600;
  background: linear-gradient(135deg, #FF6B6B, #4ECDC4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  letter-spacing: -0.01em;
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: clamp(1.2rem, 2vw, 1.4rem);
  }
}

.timeline-content {
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 28px;
  border: 1px solid rgba(255,255,255,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  }

  @media (max-width: 768px) {
    padding: 20px;
  }

  .timeline-step {
    font-family: 'Montserrat', sans-serif;
    color: #a8a8a8;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 16px;
    padding-left: 20px;
    position: relative;

    @media (max-width: 768px) {
      font-size: 0.9rem;
      padding-left: 16px;
      margin-bottom: 12px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: linear-gradient(135deg, #FF6B6B, #4ECDC4);
      transition: transform 0.3s ease;

      @media (max-width: 768px) {
        top: 8px;
        width: 5px;
        height: 5px;
      }
    }

    &:hover::before {
      transform: scale(1.2);
    }

    span {
      display: block;
      margin-top: 8px;
      transition: transform 0.3s ease;

      @media (max-width: 768px) {
        margin-top: 6px;
        margin-left: 8px !important;
        font-size: 0.85rem !important;
      }
    }

    &:hover span {
      transform: translateX(4px);
    }
  }
}

.timeline-section--highlight {
  .timeline-number {
    background: linear-gradient(135deg, rgba(255,46,95,0.2) 0%, rgba(255,46,95,0.1) 100%);
    border-color: rgba(255,46,95,0.3);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes timelineGrow {
  from {
    transform: scaleY(0);
    transform-origin: top;
  }
  to {
    transform: scaleY(1);
  }
}
</style> 